import { render, staticRenderFns } from "./PagePlansAlimentaires.vue?vue&type=template&id=8a27cbc8&scoped=true&"
import script from "./PagePlansAlimentaires.vue?vue&type=script&lang=js&"
export * from "./PagePlansAlimentaires.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a27cbc8",
  null
  
)

export default component.exports